'use strict';

var baseSearch = require('base/search/search');
var endpointLite = $('.suggestions-wrapper-lite').data('url');
var liteSearchTimer = null;

// ---------------------------------------------------------------------------
// URL query-string helpers – all PLP state lives in the URL, nothing else.
// ---------------------------------------------------------------------------

/**
 * Read a single query-string value from the current URL.
 * @param {string} key - parameter name
 * @returns {string|null} The value of the query-string parameter or null if not found
 */
function getUrlParam(key) {
    var match = window.location.search.match(new RegExp('[?&]' + key + '=([^&]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Set / update a query-string value via history.replaceState (no new history entry).
 * @param {string} key   - parameter name
 * @param {*}      value - parameter value (will be URI-encoded)
 */
function replaceUrlParam(key, value) {
    try {
        var path = window.location.pathname;
        var search = window.location.search;
        var hash = window.location.hash || '';
        var encoded = encodeURIComponent(value);
        var regex = new RegExp('([?&])' + key + '=[^&]*');

        if (regex.test(search)) {
            search = search.replace(regex, '$1' + key + '=' + encoded);
        } else {
            search += (search ? '&' : '?') + key + '=' + encoded;
        }

        window.history.replaceState({}, '', path + search + hash);
    } catch (e) {
        // degrade silently
    }
}

/**
 * Remove a single query-string key via history.replaceState.
 * @param {string} key - parameter name to remove
 */
function removeUrlParam(key) {
    try {
        var path = window.location.pathname;
        var search = window.location.search;
        var hash = window.location.hash || '';

        search = search.replace(new RegExp('([?])' + key + '=[^&]*&?'), '$1');
        search = search.replace(new RegExp('&' + key + '=[^&]*'), '');
        search = search.replace(/[?&]$/, '');

        window.history.replaceState({}, '', path + search + hash);
    } catch (e) {
        // degrade silently
    }
}

// ---------------------------------------------------------------------------
// DOM helpers
// ---------------------------------------------------------------------------

/**
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.search-sort',
        '.result-count-wrapper'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * @param {string} response - Ajax response HTML code
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortData = $tempDom.find('.grid-footer').data('sort-options');
    if (sortData && sortData.options) {
        sortData.options.forEach(function (option) {
            $('option.' + option.id).val(option.url);
        });
    }
}

/**
 * Add / update srule in the browser URL via pushState.
 * Preserves sz and start so the "Load More" count survives a re-sort.
 * Only strips the transient _scrollY param.
 * @param {string} sortRuleId - e.g. "price-high-to-low"
 */
function pushSortToUrl(sortRuleId) {
    try {
        var path = window.location.pathname;
        var search = window.location.search;
        var hash = window.location.hash || '';

        if (/[?&]srule=/.test(search)) {
            search = search.replace(/([?&]srule=)[^&]*/, '$1' + encodeURIComponent(sortRuleId));
        } else {
            search += (search ? '&' : '?') + 'srule=' + encodeURIComponent(sortRuleId);
        }

        // Only strip _scrollY – sz and start are kept so the loaded
        // product count is preserved when the user re-sorts.
        search = search.replace(/([?])_scrollY=[^&]*&?/, '$1');
        search = search.replace(/&_scrollY=[^&]*/, '');
        search = search.replace(/[?&]$/, '');

        window.history.pushState({}, '', path + search + hash);
    } catch (e) {
        // degrade silently
    }
}

// ---------------------------------------------------------------------------
// Sort restoration from URL (srule query param)
// ---------------------------------------------------------------------------

/**
 * On page init, read srule from the URL and sync the sort dropdown + label
 * so the UI reflects the active sort rule even after back-navigation or
 * BFCache restore.
 */
function restoreSortFromUrl() {
    var srule = getUrlParam('srule');
    if (!srule) return;

    var $select = $('select.search-sort');
    if ($select.length === 0) return;

    var $targetOption = $select.find('option[data-id="' + srule + '"]');
    if ($targetOption.length === 0) return;

    if (!$targetOption.is(':selected')) {
        $select.val($targetOption.val());
    }

    var label = $targetOption.text().trim();
    if (label) {
        $('.selected-sort-option-label').text(label);
    }

    $('.custom-sort-options').removeAttr('selected');
    $('.custom-sort-options[data-id="' + srule + '"]').attr('selected', '');
}

// ---------------------------------------------------------------------------
// Scroll restoration from URL (_scrollY query param)
// ---------------------------------------------------------------------------

/**
 * If the URL contains a _scrollY param, scroll to that position once the
 * page is tall enough, then remove the param from the URL.
 */
function restoreScrollFromUrl() {
    var raw = getUrlParam('_scrollY');
    if (!raw) return;

    var pos = parseInt(raw, 10);
    removeUrlParam('_scrollY');

    if (Number.isNaN(pos) || pos <= 0) return;

    var attempts = 0;
    var maxAttempts = 15;

    /**
     * Try to scroll to the position until the page is tall enough or the maximum number of attempts is reached.
     */
    function tryScroll() {
        if (document.documentElement.scrollHeight >= pos || attempts >= maxAttempts) {
            window.scrollTo(0, pos);
        } else {
            attempts += 1;
            setTimeout(tryScroll, 200);
        }
    }

    requestAnimationFrame(function () {
        setTimeout(tryScroll, 200);
    });
}

// ---------------------------------------------------------------------------
// Override: sort – adds pushState so the sort rule is part of the URL
// ---------------------------------------------------------------------------
baseSearch.sort = function () {
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:sort', this.value);
        var sortUrl = this.value;

        $.ajax({
            url: sortUrl,
            data: { selectedUrl: sortUrl },
            method: 'GET',
            success: function (response) {
                parseResults(response);

                var $selectedOption = $('select.search-sort option:selected');
                var sortId = $selectedOption.data('id');
                if (sortId) {
                    pushSortToUrl(sortId);
                }

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

// ---------------------------------------------------------------------------
// Override: showMore – persist total loaded product count in sz param
// ---------------------------------------------------------------------------
baseSearch.showMore = function () {
    $('.container').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var showMoreUrl = $(this).data('url');

        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $('.grid-footer').replaceWith(response);
                $('body').trigger('search:updateDom', '.grid-footer');
                updateSortOptions(response);

                // Keep the URL in sync with the total number of visible products
                // so a full reload (back-button) returns the same result set.
                var $footer = $('.grid-footer');
                var pageNumber = parseInt($footer.data('page-number'), 10);
                var pageSize = parseInt($footer.data('page-size'), 10);
                if (!Number.isNaN(pageNumber) && !Number.isNaN(pageSize)) {
                    replaceUrlParam('sz', (pageNumber + 1) * pageSize);
                    replaceUrlParam('start', '0');
                }

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

// ---------------------------------------------------------------------------
// Override: onPopState – full reload (URL now carries the complete state)
// ---------------------------------------------------------------------------
baseSearch.onPopState = function () {
    $(window).on('popstate', function () {
        window.location = window.location.href;
    });
};

// ---------------------------------------------------------------------------
// New: initPlpState – scroll save / restore via URL
// ---------------------------------------------------------------------------
baseSearch.initPlpState = function () {
    if ($('.product-grid').length === 0) return;

    restoreSortFromUrl();
    restoreScrollFromUrl();

    // Stamp the current scroll offset into the URL right before navigating
    // to a product page so the back-button can restore it.
    $(document).on('click', '.product a[href], .product-tile a[href]', function () {
        var scrollY = window.scrollY || window.pageYOffset;
        if (scrollY > 0) {
            replaceUrlParam('_scrollY', scrollY);
        }
    });
};

// ---------------------------------------------------------------------------
// Override: applyFilter (existing app_barry customisation kept intact)
// ---------------------------------------------------------------------------
baseSearch.applyFilter = function () {
    $(document).on('click', '.selected-sort-option', function (e) {
        e.stopPropagation();
        $('.sort-modal').toggleClass('d-none d-block');
    });

    $(document).on('click', function (e) {
        if (!$('.sort-modal').is(e.target) && $('.sort-modal').has(e.target).length === 0
            && !$('.selected-sort-option').is(e.target) && $('.selected-sort-option').has(e.target).length === 0) {
            $('.sort-modal').removeClass('d-block').addClass('d-none');
        }
    });

    // Handle refinement value selection and reset click
    $('.custom-search-container, .conatiner').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, a.reset, .filter-value button, .filter-value a, .swatch-filter button, .boolean-refinement-slider',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.spinner().start();
            $(this).trigger('search:filter', e);
            var activeSrule = getUrlParam('srule');
            var searchUrl = $(this).data('href');
            var seoUrl = $(this).data('seo-href') || searchUrl;
            if (seoUrl && !seoUrl.toLowerCase().includes('ajax')) {
                window.history.pushState({}, null, seoUrl);
            }
            if (activeSrule) {
                replaceUrlParam('srule', activeSrule);
            }

            var attributeId = '#' + $(this).find('span').last().attr('id');
            $.ajax({
                url: searchUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: searchUrl
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                },
                error: function () {
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                }
            });
        }
    );

    $(document).on('click', '.custom-sort-options, .custom-sort-btn', function () {
        var id = $(this).data('id');

        var $select = $('select.search-sort');
        $select.val($select.find('option[data-id="' + id + '"]').val()).trigger('change');
    });

    // Keyboard accessibility for sort options
    $(document).on('keydown', '.custom-sort-options, .custom-sort-btn', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    // Keyboard accessibility for selected sort label
    $(document).on('keydown', '.selected-sort-option-label', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    $('.container').on('click', 'button.filter-results', function () {
        $('.refinement-bar').addClass('filter-open');
        $('.modal-background').addClass('filter-open');
        $('body').addClass('no-scroll');
    });

    $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
        $('.refinement-bar').removeClass('filter-open');
        $('.modal-background').removeClass('filter-open');
        $('body').removeClass('no-scroll');
    });

    // Keyboard accessibility for refinement header spans (desktop filter headers)
    $(document).on('keydown', '.refinement-header span[role="button"]', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            // Toggle the accordion by clicking the circle-chevron or triggering accordion logic
            var $accordionItem = $(this).closest('.accordian-item');
            $accordionItem.toggleClass('active');
        }
    });

    // Keyboard accessibility for sort label spans
    $(document).on('keydown', '.sort-label[role="button"]', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            // Trigger the parent button click
            $(this).closest('.custom-sort-btn').trigger('click');
        }
    });

    // Search as you type for lite search
    $(document).on('keyup', '.search-bar-lite-input', function (e) {
        e.stopPropagation(); // Prevent event bubbling
        var $input = $(this);
        var value = $input.val();
        var $wrapper = $('.suggestions-wrapper-lite');

        // Clear previous timer
        clearTimeout(liteSearchTimer);

        liteSearchTimer = setTimeout(function () {
            if (value.length > 2 && endpointLite) {
                $.ajax({
                    url: endpointLite + encodeURIComponent(value) + '&version=lite',
                    method: 'GET',
                    success: function (response) {
                        if (response && response.length > 0) {
                            $wrapper.html(response).show();
                        } else {
                            $wrapper.empty().hide();
                        }
                    },
                    error: function () {
                        $wrapper.empty().hide();
                    }
                });
            } else {
                $wrapper.empty().hide();
            }
        }, 500); // ⏱️ 500ms debounce
    });

    // Hide suggestions when clicking outside the search bar
    // Exclude search modal clicks to prevent interference
    $(document).on('click touchstart', function (e) {
        // Don't hide if clicking inside search modal
        if ($(e.target).closest('#searchModal').length) {
            return;
        }

        if (!$(e.target).closest('.search-bar-lite-input').length && !$(e.target).closest('.suggestions-wrapper-lite').length) {
            $('.suggestions-wrapper-lite').empty().hide();
        }
    });

    /**
     * Toggle filters visibility based on active tab
     * Hide filters when Articles tab is active, show when Products tab is active
     * Only runs on search results pages (not PLP)
     */
    function toggleFiltersVisibility() {
        var $filtersWrapper = $('#search-filters-wrapper');

        // Only run on search results pages (not PLP)
        // PLP doesn't have #search-filters-wrapper
        if ($filtersWrapper.length === 0) {
            return;
        }

        /**
         * Update filters visibility based on active tab
         * @param {string} tabId - The ID of the active tab pane
         */
        function updateFiltersVisibility(tabId) {
            if (tabId === 'content-search-results-pane') {
                // Articles tab active - hide filters
                $filtersWrapper.addClass('d-none');
            } else {
                // Products tab active - show filters
                $filtersWrapper.removeClass('d-none');
            }
        }

        // Listen to Bootstrap tab events
        $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function () {
            var targetTab = $(this).attr('aria-controls') || $(this).attr('href');
            if (targetTab && targetTab.indexOf('#') === 0) {
                targetTab = targetTab.substring(1);
            }
            updateFiltersVisibility(targetTab);
        });

        // Initial state - check which tab is active
        var $activeTab = $('.nav-link.active[data-toggle="tab"]');
        if ($activeTab.length > 0) {
            var activeTabId = $activeTab.attr('aria-controls') || $activeTab.attr('href');
            if (activeTabId && activeTabId.indexOf('#') === 0) {
                activeTabId = activeTabId.substring(1);
            }
            updateFiltersVisibility(activeTabId);
        } else {
            // Check active tab pane directly
            var $activePane = $('.tab-pane.active');
            if ($activePane.length > 0) {
                var paneId = $activePane.attr('id');
                updateFiltersVisibility(paneId);
            }
        }
    }

    /**
     * Toggle trending searches visibility based on active tab and results
     */
    function toggleTrendingSearches() {
        var $trending = $('.trending-searches-container');
        if ($trending.length === 0) {
            return;
        }

        // Content tab shown
        $(document).on('shown.bs.tab', 'a[href="#content-search-results-pane"]', function () {
            var hasResults = $trending.data('content-results') === true;
            $trending.toggleClass('d-none', hasResults);
        });

        // Product tab shown
        $(document).on('shown.bs.tab', 'a[href="#product-search-results"]', function () {
            var hasResults = $trending.data('product-results') === true;
            $trending.toggleClass('d-none', hasResults);
        });
    }

    // Initialize filters toggle
    toggleFiltersVisibility();

    // Initialize trending searches toggle
    toggleTrendingSearches();
};

/**
 * Mobile floating filter button visibility logic
 */
function initFloatingButtonVisibility() {
    var isMobile = $(window).width() < 768;
    if (!isMobile) return;

    var currentUrl = window.location.pathname;
    var previousUrl = sessionStorage.getItem('floatingButtonPageUrl');
    var wasShown = sessionStorage.getItem('floatingButtonShown') === 'true';

    // Reset flag if user navigated to different page
    if (previousUrl && previousUrl !== currentUrl) {
        sessionStorage.removeItem('floatingButtonShown');
        sessionStorage.removeItem('floatingButtonPageUrl');
        window.floatingButtonShown = false;
    } else {
        window.floatingButtonShown = window.floatingButtonShown || wasShown;
    }

    // eslint-disable-next-line require-jsdoc
    function hasFilters() {
        return $('.filter-bar').find('.applied-filter, .swatch-filter').length > 0;
    }

    // eslint-disable-next-line require-jsdoc
    function isMarkerVisible() {
        var $marker = $('.js-third-row-marker');
        if ($marker.length === 0) return false;
        var rect = $marker[0].getBoundingClientRect();
        return rect.top >= 0 && rect.top <= window.innerHeight;
    }

    // eslint-disable-next-line require-jsdoc
    function updateVisibility() {
        var $button = $('.custom-mobile-filter-button');
        var shouldShow = window.floatingButtonShown || hasFilters() || isMarkerVisible();

        if (shouldShow) {
            $button.removeClass('d-none').addClass('d-flex');
            window.floatingButtonShown = true;
            sessionStorage.setItem('floatingButtonShown', 'true');
            sessionStorage.setItem('floatingButtonPageUrl', currentUrl);
        } else {
            $button.removeClass('d-flex').addClass('d-none');
        }
    }

    updateVisibility();
    $(window).off('scroll.floatingButton').on('scroll.floatingButton', function() {
        if (!window.floatingButtonShown) {
            updateVisibility();
        }
    });
}

// Initialize floating button visibility on page load
baseSearch.initFloatingButtonVisibility = initFloatingButtonVisibility;

// Call once on page load
$(document).ready(function () {
    initFloatingButtonVisibility();
});

// Re-initialize when filters are applied/removed (AJAX updates)
$('body').on('search:updateDom', function(e, selector) {
    if (selector === '.filter-bar' || selector === '.product-grid') {
        initFloatingButtonVisibility();
    }
});

// ---------------------------------------------------------------------------
// Override: clearSearch – clear search input and suggestions
// ---------------------------------------------------------------------------
baseSearch.clearSearch = function () {
    $(document).on('click', '.search-bar-clear-button', function () {
        $('.search-bar-lite-input').val('').focus();
        $('.suggestions-wrapper-lite').empty().hide();
        $('.search-bar-clear-button').addClass('d-none');
    });

    $(document).on('keyup', '.search-bar-lite-input', function (e) {
        var value = $(this).val();
        if (value.length > 0) {
            $('.search-bar-clear-button').removeClass('d-none');
        } else {
            $('.search-bar-clear-button').addClass('d-none');
        }
    });
};

module.exports = baseSearch;
